/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelFormTextarea64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelFormTextarea64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M8 18C8 15.7909 9.79086 14 12 14H52C54.2091 14 56 15.7909 56 18V46C56 48.2091 54.2091 50 52 50H12C9.79086 50 8 48.2091 8 46V18Z"
            fill="currentColor"
          />
          <g opacity="0.1">
            <path
              d="M46.8536 47.8536L53.8536 40.8536L53.1465 40.1465L46.1465 47.1465L46.8536 47.8536Z"
              fill="currentColor"
            />
            <path
              d="M50.8536 47.8536L53.8536 44.8536L53.1465 44.1465L50.1465 47.1465L50.8536 47.8536Z"
              fill="currentColor"
            />
          </g>
          <g>
            <path d="M13 19L13 30H14L14 19H13Z" fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 18C8 15.7909 9.79086 14 12 14H52C54.2091 14 56 15.7909 56 18V46C56 48.2091 54.2091 50 52 50H12C9.79086 50 8 48.2091 8 46V18ZM12 15H52C53.6569 15 55 16.3431 55 18V46C55 47.6569 53.6569 49 52 49H12C10.3431 49 9 47.6569 9 46V18C9 16.3431 10.3431 15 12 15Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelFormTextarea64Icon.tags = ['text', 'input', 'form', 'textarea', 'box'];

AddPanelFormTextarea64Icon.category = '64x64 (Add panel)';

AddPanelFormTextarea64Icon.iconSize = 64;
